import { createSelector } from 'reselect';

const userProfileSelector = (state) => state.userProfile;

export const isLogin = createSelector(
  userProfileSelector,
  (userProfile) => !userProfile.loading && userProfile.data !== null
);

export const isLoading = createSelector(userProfileSelector, (userProfile) => userProfile.loading);

export const myProfile = createSelector(userProfileSelector, (userProfile) => userProfile.data);

export const loginError = createSelector(userProfileSelector, (userProfile) => userProfile.error);

export const myRoles = createSelector(
  userProfileSelector,
  (userProfile) => (userProfile.data && userProfile.data.roles) || []
);

export const myUsername = createSelector(
  userProfileSelector,
  (userProfile) => (userProfile.data && userProfile.data.username) || null
);

export const myLoginType = createSelector(userProfileSelector, (userProfile) => {
  if (userProfile.data && userProfile.data.username) {
    const { username } = userProfile.data;
    const splitIdx = username.indexOf('.');
    if (splitIdx === -1) return null;
    const loginType = username.substring(0, splitIdx);
    return loginType;
  }
  return null;
});
